module.exports = __webpack_public_path__ + "c1b44a05bd2a4a4b3d8d25c5f7bb4394.png";